import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ActionCreator, MemoizedSelector, Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { concatMap, from, withLatestFrom } from 'rxjs';

export abstract class QueryParamSyncEffectsBaseEffect<S, A extends { type: string }> {
  protected abstract readonly actions$: Actions;
  protected abstract readonly store: Store;
  protected abstract readonly router: Router;
  protected abstract readonly route: ActivatedRoute;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected createSetQueryParamsEffect(triggerActions: ActionCreator<string, (props?: any) => A>[]) {
    return createEffect(
      () =>
        this.actions$.pipe(
          ofType(...triggerActions),
          withLatestFrom(this.store.select(this.getStateSelector())),
          concatMap(([action, state]) => {
            const queryParams = {
              ...this.getParamsFromState(state),
              ...this.getQueryParam(action),
            };

            return from(
              // eslint-disable-next-line twaice/no-router-navigate-outside-effects
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams,
                queryParamsHandling: 'merge',
              })
            );
          })
        ),
      { dispatch: false }
    );
  }

  protected abstract getParamsFromState(state: S): Record<string, string | string[] | number | null | undefined>;
  protected abstract getQueryParam(action: A): Record<string, string | string[] | number | null | undefined>;
  protected abstract getStateSelector(): MemoizedSelector<object, S>;
}
